import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function GetRolesByUserService(token, userId) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(`${URL_AUTH}/api/admin/v1/admins/${userId}/role/list`, {
        headers: {
          "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
          Authorization: `Bearer ${token}`,
        }
      });
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
}